import styled, {createGlobalStyle} from 'styled-components';

import {ms} from '@yourcoach/shared/styles/normalizeSize';
import {getColor} from '@yourcoach/shared/styles/utils';
import {View} from '@yourcoach/shared/uikit/View';

const Container = styled(View)`
  display: grid;
  grid-template-columns: 90px 1fr;
  grid-template-rows: 80px 1fr;
  grid-template-areas:
    'menu header'
    'menu content';
  height: 100%;
`;
const Header = styled.header`
  padding-left: ${ms(40)};
  padding-right: ${ms(130)};
  grid-area: header;
  display: flex;
  justify-content: space-between;
  background-color: ${getColor('lostColors.pageBg')};
`;
const Menu = styled.nav`
  grid-area: menu;
`;
const Content = styled.main`
  padding-left: ${ms(40)};
  padding-right: ${ms(130)};
  height: 100%;
  grid-area: content;
  background-color: ${getColor('lostColors.pageBg')};
`;

export const Layout = {
  Container,
  Content,
  Header,
  Menu,
};

export const GlobalStyles = createGlobalStyle`
  body, html {
    min-width: ${ms(1200)};
    overflow-y: hidden;
  }
`;
